import { Box, Typography } from '@mui/material';

import { THOR_COLORS } from '../theme/thorTheme';
import Header from '@/components/Header';

export const MolmoManip = () => {
  return (
    <Box>
      <Header />
      <Box
        sx={{
          backgroundColor: 'background.paper',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '1400px',
          margin: 'auto',
          mt: 6,
          px: 3,
          pb: 6,
        }}
      >
        <Typography variant="h3" sx={{ mb: 2, color: THOR_COLORS.cream }}>
          Molmo-Manip
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: THOR_COLORS.cream, opacity: 0.8 }}>
          Advancing models for robotics. Coming soon...
        </Typography>
      </Box>
    </Box>
  );
};
